<template>
  <highcharts :constructor-type="'mapChart'" :options="chartOptions"></highcharts>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'HeatMapChart',
  data () {
    return {
      heatmapChartData: {
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates']),
    chartOptions: function () {
      return {
        chart: {
          type: 'heatmap',
          marginTop: 40,
          marginBottom: 80,
          plotBorderWidth: 1
        },
        title: {
          text: ''
        },
        colorAxis: {
          min: -1,
          minColor: '#FFFFFF',
          maxColor: '#073a8c',
          gridLineColor: '#FFFFFF'
        },
        xAxis: {
          type: 'string',
          categories: [],
          visible: true,
          title: {
            text: 'hour of day'
          }
        },
        yAxis: {
          type: 'data',
          categories: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          visible: true,
          title: {
            text: 'weekday'
          }
        },
        legend: {
          enabled: false,
          align: 'right',
          layout: 'vertical',
          margin: 0,
          verticalAlign: 'top',
          y: 25,
          symbolHeight: 280
        },
        tooltip: {
          formatter: function () {
            return '<b>' + this.point.value + ' conversations </b>'
          }
        },
        series: [{
          borderWidth: 1,
          borderColor: '#FFFFFF',
          data: this.heatmapChartData.data
        }]
      }
    }
  },

  methods: {
    getChartData () {
      if (!this.currentReportMailbox.id) {
        return false
      }
      var vm = this
      this.$http.get('/heat_map_chart_data', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.heatmapChartData.data = response.data
        })
        .catch(e => { console.log(e) })
    }
  },
  watch: {
    currentReportMailbox () {
      this.getChartData()
    },
    reportDates () {
      this.getChartData()
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/HeatMapChart.vue